<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_2" viewBox="0 0 27.32 32.69">
    <g id="Camada_1-2" data-name="Camada_1">
      <g>
        <path d="M23.17,11.61H4.15c-2.29,0-4.15,1.84-4.15,4.11v12.86c0,2.27,1.86,4.11,4.15,4.11h19.01c2.29,0,4.15-1.84,4.15-4.11v-12.86c0-2.27-1.86-4.11-4.15-4.11ZM24.86,27.41c0,1.64-1.37,2.96-3.07,2.96H5.53c-1.7,0-3.07-1.33-3.07-2.96v-10.84c0-1.64,1.37-2.96,3.07-2.96h16.25c1.7,0,3.07,1.33,3.07,2.96v10.84Z"/>
        <path d="M7.11,11.61v-2.5c0-3.68,2.98-6.66,6.66-6.66s6.66,2.98,6.66,6.66v2.5h2.93c.02-.25.04-.5.04-.76v-1.12C23.4,4.36,19.04,0,13.66,0S3.92,4.36,3.92,9.74v1.12c0,.26.02.51.04.76h3.15Z"/>
        <rect x="12.19" y="18.61" width="2.93" height="7.18" rx="1.46" ry="1.46"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PrivacyIcon'
}
</script>
